var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4"},[_c('vx-card',[_c('span',[_vm._v("hola")]),_c('span',[_vm._v(_vm._s(_vm.curso))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }